// routes.js

import Error404 from "../views/Error404";
import Prediction from "../views/homepage/Prediction";
import Impressum from "@/views/impressum/Impressum";

const routes = [
    {
        path: '/',
        name: 'predictions',
        component: Prediction
    }, {
        path: '/impressum',
        name: 'impressum',
        component: Impressum
    },
    {
        path: '*',
        component: Error404
    }
];

export default routes;